import React from "react";
import { Link } from "react-router-dom";

/**
 * LoginPage: Simple redirect page to inventory system
 * Note: Actual login handled by external inventory app
 */
const LoginPage: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Welcome Back</h1>
          <p className="text-gray-600">Sign in to your ReadyToClaim account</p>
        </div>
        
        <div className="bg-white rounded-lg shadow-lg p-8">
          <div className="text-center mb-6">
            <p className="text-gray-600 mb-4">
              ReadyToClaim uses the same login system as our inventory tool.
            </p>
            <Link
              to="/inventory-web"
              className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg transition-colors duration-200 w-full"
            >
              Go to Inventory System
            </Link>
          </div>
          
          <div className="text-center">
            <p className="text-sm text-gray-500">
              Don't have an account?{" "}
              <Link to="/try" className="text-blue-600 hover:text-blue-700">
                Get started here
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage; 